import { getGroups, getListsCount, getDepartments } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';
import { confirmAlert } from 'react-confirm-alert';

import { ConfirmImpossibilityOfDepartmentDeletion } from './ConfirmImpossibilityOfDepartmentDeletion';

export interface CheckDeleteDepartmentPossibilityParams {
  departmentId: DepartmentId;
}

export type CheckDeleteDepartmentPossibilityResult = 'possible' | 'impossible';

async function checkDeleteDepartmentPossibility({
  departmentId,
}: CheckDeleteDepartmentPossibilityParams): Promise<CheckDeleteDepartmentPossibilityResult> {
  const [listsCount, groupsDetails, departmentsDetails] = await Promise.all([
    getListsCount({ owner_department_ids: [departmentId] }),
    getGroups({ owner_department_ids: [departmentId] }),
    getDepartments({ parent_department_ids: departmentId }),
  ]);

  const hasOwnedLists = Boolean(listsCount.lists_count > 0);
  const hasOwnedGroups = Boolean(groupsDetails.groups?.length);
  const hasOwnedDepartments = Boolean(departmentsDetails.departments?.length);

  if (hasOwnedLists || hasOwnedGroups || hasOwnedDepartments) {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmImpossibilityOfDepartmentDeletion onConfirm={() => onClose()} />
      ),
    });
    return 'impossible';
  }

  return 'possible';
}

export { checkDeleteDepartmentPossibility };
